import Utils from "../../services/Utils.js";
export function getLiveTemplate(game) {
  if (!game.odd) {
    return "";
  }
  return `
        <div class="singleOrderIdHolder singleGameContent flex flex-row flex-wrap w-full px-1 first:pt-[0] items-center border-b [border-bottom-color:#6f6c6c]" data-game-value="${
          game.sport_id
        }" id="${game.id}">
            <a class="singleTeamNames cursor-text w-[90px]" data-id="${
              game.id
            }">
                <div class="flex flex-row flex-wrap singleDateColumn text-[11px] font-medium text-white leading-[20px] bg-black bg-opacity-[0.7] px-1 py-[1px] border-r [border-right-color:#373535] ">
                    <div class="flex flex-wrap flex-row justify-between w-full">
                        <span class="inline-block max-w-[calc(100%-15px)] overflow-hidden text-ellipsis whitespace-nowrap font-medium">${
                          game.home_team
                        }</span>
                        <span class="text-[#F8DB17]">${
                          game.result.split("-")[0]
                        }</span>
                    </div>
                    <div class="flex flex-wrap flex-row justify-between w-full">
                        <span class="inline-block max-w-[calc(100%-15px)] overflow-hidden text-ellipsis whitespace-nowrap font-medium">${
                          game.away_team
                        }</span>
                        <span class="text-[#F8DB17]">${
                          game.result.split("-")[1]
                        }</span>
                    </div>
                </div>
            </a>
            <div class="w-[calc(100%-90px)] flex flex-row flex-wrap">
                <div class="flex w-full bg-black bg-opacity-[0.4] border-b [border-top-color:#373535] [border-bottom-color:#6f6c6c] ">
                    <div class="flex flex-row flex-wrap singleDateColumn">
                        ${
                          game.sport_id != 5
                            ? `<span id="${game.id}-timer" class="flex w-full w-[45px] text-center text-[11px] leading-[20px] text-white justify-center font-[verdana]">${game.current_minute}</span>`
                            : `<span id="${game.id}" class="flex w-full w-[40px] text-center text-[11px] leading-[20px] text-white justify-center font-[verdana]">-</span>`
                        }
                    </div>
                    <div class="flex flex-row flex-wrap singleDateColumn w-full text-[11px] font-medium text-white leading-[20px] justify-between">
                        <span>Rezultat fina</span>
                        <a href="#/livematch/${
                          game.id
                        }" class="hover:underline"> +${
    game.count_options
  } > </a>
                    </div>
                </div>
                    <div 
                        class="
                            flex
                            cursor-pointer
                            ${
                              game.sport_id == 2 ||
                              game.sport_id == 5 ||
                              game.sport_id == 10 ||
                              game.sport_id == 3 ||
                              game.sport_id == 20
                                ? `w-[177px]`
                                : "w-[118px]"
                            }
                            text-white
                            text-[11px]
                            leading-[20px]
                            px-2
                            bg-white/10
                            hover:bg-[#8d741d]
                            justify-between
                            mr-[1px]
                            singleHomeOdd 
                            bettingBtn 
                            ${
                              Utils.formatNumber(
                                game.odd.split(",")[0].split("|")[1]
                              ) == 1
                                ? "disabledBtn"
                                : ""
                            }
                            ${
                              game.odd.split(",").length > 0
                                ? game.odd.split(",")[0].split("|")[0]
                                : "disabledBtn"
                            } 
                            ${game.odd.split(",")[0].split("|")[0]}-coef
                        " 
                        match-code="Live"
                        match-odd="${Utils.formatNumber(
                          game.odd.split(",")[0].split("|")[1]
                        )}" 
                        match-home-name="${game.home_team}" 
                        match-away-name="${game.away_team}" 
                        match-market="${
                          ["1", "X", "2"].includes(
                            game.odd.split(",")[0].split("|")[2]
                          )
                            ? "Rezultat final"
                            : game.odd.split(",")[0].split("|")[2]
                        }" 
                        coef-id="${
                          game.odd.split(",")[0].split("|")[0]
                        }" bet-id="${game.odd.split(",")[0].split("|")[0]}"
                        match-market-option="1" 
                        match-is-live="1" 
                        game-id="${game.id}"
                    >
                        <span class="${
                          game.sport_id == 2 ||
                          game.sport_id == 5 ||
                          game.sport_id == 10 ||
                          game.sport_id == 3 ||
                          game.sport_id == 20
                            ? `w-[140px]`
                            : "w-[75px]"
                        } truncate whitespace-nowrap overflow-hidden text-ellipsis">${
    game.home_team
  }</span>
                        <span>${Utils.formatNumber(
                          game.odd.split(",")[0].split("|")[1]
                        )}</span>
                    </div>     
                    <div 
                        class="
                            flex
                            cursor-pointer
                            ${
                              game.sport_id == 2 ||
                              game.sport_id == 5 ||
                              game.sport_id == 10 ||
                              game.sport_id == 3 ||
                              game.sport_id == 20
                                ? `w-[177px]`
                                : "w-[118px]"
                            }
                            text-white
                            text-[11px]
                            leading-[20px]
                            px-2
                            bg-white/10
                            hover:bg-[#8d741d]
                            mr-[1px]
                            justify-between
                            singleDrawOdd 
                            bettingBtn
                            ${
                              game.odd.split(",").length > 1 &&
                              Utils.formatNumber(
                                game.odd.split(",")[1].split("|")[1]
                              ) == 1
                                ? "disabledBtn"
                                : ""
                            }  
                            ${
                              game.odd.split(",").length > 1
                                ? game.odd.split(",")[1].split("|")[0]
                                : "disabledBtn"
                            } 
                            ${
                              game.odd.split(",").length > 1
                                ? game.odd.split(",")[1].split("|")[0]
                                : "1.00"
                            }-coef
                        "
                        match-code="Live"
                        match-is-live="1" 
                        match-odd="${
                          game.odd.split(",").length > 1
                            ? Utils.formatNumber(
                                game.odd.split(",")[1].split("|")[1]
                              )
                            : ""
                        }" 
                        match-home-name="${game.home_team}" 
                        match-away-name="${game.away_team}" 
                        match-market="${
                          ["1", "X", "2"].includes(
                            game.odd.split(",")[0].split("|")[2]
                          )
                            ? "Rezultat final"
                            : game.odd.split(",")[0].split("|")[2]
                        }" 
                        match-market-option="X" 
                        coef-id="${
                          game.odd.split(",").length > 1
                            ? game.odd.split(",")[1].split("|")[0]
                            : ""
                        }" bet-id="${
    game.odd.split(",").length > 1 ? game.odd.split(",")[1].split("|")[0] : ""
  }" game-id="${game.id}"
                    >
                        <span class="${
                          game.sport_id == 2 ||
                          game.sport_id == 5 ||
                          game.sport_id == 10 ||
                          game.sport_id == 3 ||
                          game.sport_id == 20
                            ? `w-[75px] truncate whitespace-nowrap overflow-hidden text-ellipsis`
                            : ""
                        }">${
    game.sport_id == 2 ||
    game.sport_id == 5 ||
    game.sport_id == 10 ||
    game.sport_id == 20
      ? game.away_team
      : "X"
  }</span>
                        <span>${
                          game.odd.split(",").length > 1
                            ? Utils.formatNumber(
                                game.odd.split(",")[1].split("|")[1]
                              )
                            : ""
                        }</span>
                    </div>
                    ${
                      game.odd.split(",").length == 3 &&
                      game.odd.split(",")[2].split("|").length > 1
                        ? `
                        <div 
                            class="
                                flex
                                cursor-pointer
                                w-[118px]
                                text-white
                                text-[11px]
                                leading-[20px]
                                px-2
                                font-[verdana]
                                bg-white/10
                                hover:bg-[#8d741d]
                                justify-between
                                singleAwayOdd 
                                bettingBtn 
                                ${
                                  game.odd.split(",").length > 2 &&
                                  Utils.formatNumber(
                                    game.odd.split(",")[2].split("|")[1]
                                  ) == 1
                                    ? "disabledBtn"
                                    : ""
                                } 
                                ${
                                  game.odd.split(",").length > 2
                                    ? game.odd.split(",")[2].split("|")[0]
                                    : "disabledBtn"
                                }  
                                ${
                                  Math.floor(
                                    (parseFloat(
                                      game.odd.split(",")[0].split("|")[1]
                                    ) +
                                      Number.EPSILON) *
                                      100
                                  ) /
                                    100 ==
                                  1
                                    ? "disabledBtn"
                                    : ""
                                } 
                                ${
                                  game.odd.split(",").length > 2
                                    ? game.odd.split(",")[2].split("|")[0]
                                    : "1.00"
                                }-coef
                            "  
                            match-code="Live"
                            match-is-live="1" 
                            match-odd="${
                              game.odd.split(",").length > 2
                                ? Utils.formatNumber(
                                    game.odd.split(",")[2].split("|")[1]
                                  )
                                : "0.00"
                            }" 
                            match-home-name="${game.home_team}" 
                            match-away-name="${game.away_team}" 
                            match-market="${
                              ["1", "X", "2"].includes(
                                game.odd.split(",")[0].split("|")[2]
                              )
                                ? "Rezultat final"
                                : game.odd.split(",")[0].split("|")[2]
                            }" 
                            match-market-option="2 " 
                            coef-id="${
                              game.odd.split(",").length > 2
                                ? game.odd.split(",")[2].split("|")[0]
                                : ""
                            }" 
                            bet-id="${
                              game.odd.split(",").length > 2
                                ? game.odd.split(",")[2].split("|")[0]
                                : ""
                            }" 
                            game-id="${game.id}"
                        >
                            <span class="w-[75px] truncate whitespace-nowrap overflow-hidden text-ellipsis">${
                              game.away_team
                            }</span>
                            <span>${
                              game.odd.split(",").length > 2
                                ? Utils.formatNumber(
                                    game.odd.split(",")[2].split("|")[1]
                                  )
                                : ""
                            }</span>
                        </div>
                    `
                        : ``
                    }
        </div>
                    </div>
    `;
}
export function getLiveTemplateEvent(game) {
  if (
    !game.delimited_odd ||
    !game.delimited_coeficient_id ||
    !game.delimited_market_option
  ) {
    return "";
  }

  return `
        <div class="singleGameContent singleOrderIdHolder" data-game-value="${
          game.sport_id
        }" id="" id="${game.id}">
            <a class="singleTeamNames" href="#/livematch/${game.id}" data-id="${
    game.id
  }">
                <div class="singleDateColumn">
                    <span id='${game.id}-timer'>${game.current_minute}</span>
                    <span class="numberofmarkets">${game.count_options} ></span>
                </div>
                <div class="singleDetailsColumn">
                    <div class="singleTeamRowLabel">
                        <span class="singleHomeName">${game.home_team}</span>
                        <span class="gameSingleHomeScore"></span>
                    </div>
                    <div class="singleTeamRowLabel">
                        <span class="singleAwayName">${game.away_team}</span>
                        <span class="gameSingleAwayScore"></span>
                    </div>
                </div>
                <div class="singleMatchResult">
                    <span>${
                      game.result.split("-") &&
                      game.result.split("-").length > 0
                        ? game.result.split("-")[0]
                        : ""
                    }</span>
                    <span>${
                      game.result.split("-") &&
                      game.result.split("-").length > 1
                        ? game.result.split("-")[1]
                        : ""
                    }</span>
                </div>
            </a>
            <div 
                class="
                    singleHomeOdd 
                    bettingBtn 
                    ${
                      Utils.formatNumber(
                        game.odd.split(",")[0].split("|")[1]
                      ) == 1
                        ? "disabledBtn"
                        : ""
                    } 
                    ${
                      game.odd.split(",").length > 0
                        ? game.odd.split(",")[0].split("|")[0]
                        : "disabledBtn"
                    } 
                    ${game.odd.split(",")[0].split("|")[0]}-coef
                " 
                match-code="Live"
                match-odd="${Utils.formatNumber(
                  game.odd.split(",")[0].split("|")[1]
                )}" 
                match-home-name="${game.home_team}" 
                match-away-name="${game.away_team}" 
                match-market="${game.odd.split(",")[0].split("|")[2]}" 
                coef-id="${game.odd.split(",")[0].split("|")[0]}" 
                bet-id="${game.odd.split(",")[0].split("|")[0]}" 
                game-id="${game.id}"
            >
                ${Utils.formatNumber(game.odd.split(",")[0].split("|")[1])}
            </div>
            <div 
                class="
                    singleDrawOdd 
                    bettingBtn 
                    ${
                      game.odd.split(",").length > 1 &&
                      Utils.formatNumber(
                        game.odd.split(",")[1].split("|")[1]
                      ) == 1
                        ? "disabledBtn"
                        : ""
                    }  
                    ${
                      game.odd.split(",").length > 1
                        ? game.odd.split(",")[1].split("|")[0]
                        : "disabledBtn"
                    } 
                    ${
                      game.odd.split(",").length > 1
                        ? game.odd.split(",")[1].split("|")[0]
                        : "1.00"
                    }-coef
                " 
                match-code="Live"
                match-odd="${
                  game.odd.split(",").length > 1
                    ? Utils.formatNumber(game.odd.split(",")[1].split("|")[1])
                    : ""
                }" 
                match-home-name="${game.home_team}" 
                match-away-name="${game.away_team}" 
                match-market="${
                  game.odd.split(",").length > 1
                    ? game.odd.split(",")[1].split("|")[2]
                    : ""
                }" 
                coef-id="${
                  game.odd.split(",").length > 1
                    ? game.odd.split(",")[1].split("|")[0]
                    : ""
                }" 
                bet-id="${
                  game.odd.split(",").length > 1
                    ? game.odd.split(",")[1].split("|")[0]
                    : ""
                }" 
                game-id="${game.id}"
            >
                ${
                  game.odd.split(",").length > 1
                    ? Utils.formatNumber(game.odd.split(",")[1].split("|")[1])
                    : ""
                }
            </div>
            <div 
                class="
                    singleAwayOdd 
                    bettingBtn 
                    ${
                      game.odd.split(",").length > 2 &&
                      Utils.formatNumber(
                        game.odd.split(",")[2].split("|")[1]
                      ) == 1
                        ? "disabledBtn"
                        : ""
                    }
                    ${
                      game.odd.split(",").length > 2
                        ? game.odd.split(",")[2].split("|")[0]
                        : "disabledBtn"
                    } 
                    ${
                      Utils.formatNumber(
                        game.odd.split(",")[0].split("|")[1]
                      ) == 1
                        ? "disabledBtn"
                        : ""
                    }
                    ${
                      game.odd.split(",").length > 2
                        ? game.odd.split(",")[2].split("|")[0]
                        : "1.00"
                    }-coef
                " 
                match-code="Live"
                match-odd="${
                  game.odd.split(",").length > 2
                    ? Utils.formatNumber(game.odd.split(",")[2].split("|")[1])
                    : "0.00"
                }" 
                match-home-name="${game.home_team}" 
                match-away-name="${game.away_team}" 
                match-market="${
                  game.odd.split(",").length > 2
                    ? game.odd.split(",")[2].split("|")[2]
                    : ""
                }" 
                coef-id="${
                  game.odd.split(",").length > 2
                    ? game.odd.split(",")[2].split("|")[0]
                    : ""
                }" 
                bet-id="${
                  game.odd.split(",").length > 2
                    ? game.odd.split(",")[2].split("|")[0]
                    : ""
                }" 
                game-id="${game.id}"
            >
                ${
                  game.odd.split(",").length > 2
                    ? Utils.formatNumber(game.odd.split(",")[2].split("|")[1])
                    : ""
                }
            </div>
        </div>
    `;
}

export function parseResultList(mainResult, resultList, isOverview, sport_id) {
  let view = "";
  if (!resultList) return;

  const returnResult = resultList
    .split(";")
    .map((item) => {
      const itemResult = item.split(",");
      if (itemResult.length >= 3) {
        return {
          type: itemResult[0],
          result:
            sport_id === "20"
              ? itemResult.at(-1).split("-")
              : itemResult[1].split(":"),
          set: parseInt(itemResult[2]),
        };
      }
      return null;
    })
    .filter((i) => i !== null)
    .sort(({ set: a }, { set: b }) => a - b);

  if (mainResult) {
    const item = mainResult.split("-");
    view += `<div><div>${item[0] ?? ""}</div><div>${item[1] ?? ""}</div></div>`;
  } else {
    view += `<div><div></div><div></div></div>`;
  }

  if (returnResult.some((r) => r.type === "1")) {
    const items = returnResult.filter((r) => r.type === "1");
    if (isOverview && sport_id === 5) {
      // show last set only for tennis in overview
      const item = items.pop();
      view += `<div><div>${item.result[0] ?? 0}</div><div>${
        item.result[1] ?? 0
      }</div></div>`;
    } else if (!isOverview) {
      items.forEach((item) => {
        view += `<div><div>${item.result[0] ?? 0}</div><div>${
          item.result[1] ?? 0
        }</div></div>`;
      });
    }
  }

  // if (isOverview && returnResult.some(r => r.type === '5')) {
  //   const items = returnResult.filter(r => r.type === '5');
  //   items.forEach(item => {
  //     view += `<div><div>${item.result[0] ?? 0}</div><div>${item.result[1] ?? 0}</div></div>`;
  //   });
  // }

  if (
    (isOverview || sport_id === "20") &&
    returnResult.some((r) => r.type === "4")
  ) {
    const items = returnResult.filter((r) => r.type === "4");
    items.forEach((item) => {
      view += `<div><div>${item.result[0] ?? 0}</div><div>${
        item.result[1] ?? 0
      }</div></div>`;
    });
  }

  return view;
}
